import { Component, OnInit, HostListener } from '@angular/core';
import { NavService } from '../nav.service';

declare const window: any;

@Component({
  selector: 'ae-scroll-position',
  templateUrl: './scroll-position.component.html',
  styles: []
})
export class ScrollPositionComponent implements OnInit {

  constructor(private navService: NavService) { }

  ngOnInit() {
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {

    const scrollNumber = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    if (scrollNumber < 100) {
      this.navService.setNavPosition('top');
    } else {
        this.navService.setNavPosition('bottom');
    }

  }
}
